import React, { useEffect } from 'react';

import { CloseButton, Heading, ModalDialog } from '@zillow/constellation';
import type { MODAL_DIALOG_SIZES } from '@zillow/constellation';

import styled, { css } from 'styled-components';

import { mediaMixin, spaceMixin } from '@zillow/constellation';

export const StyledModalWrapperContainer = styled.div`
  margin: 0;

  ${mediaMixin(
    'md',
    css`
      margin: ${({ hasBodyMargin }: { hasBodyMargin: boolean }) =>
        hasBodyMargin ? `${spaceMixin('sm')} ${spaceMixin(10)} ${spaceMixin('sm')}` : 0};
    `,
  )};
`;

interface ModalWrapperTypes {
  children: React.ReactNode;
  footer?: React.ReactNode;
  heading?: string | React.ReactNode;
  isWide?: boolean;
  onClose: () => void;
  onOpen?: () => void;
  scrollDocument?: boolean;
  shouldCloseOnOverlayClick?: boolean;
  portal?: boolean;
  hasBodyMargin?: boolean;
  closeModalOnBackButton?: boolean;
  useChildrenForDialogBody?: boolean;
  size?: typeof MODAL_DIALOG_SIZES;
}

export const ModalWrapper = ({
  children,
  footer = null,
  heading = null,
  isWide = true,
  onClose,
  onOpen = () => {},
  scrollDocument = false,
  shouldCloseOnOverlayClick = true,
  portal = true,
  hasBodyMargin = true,
  closeModalOnBackButton = true,
  useChildrenForDialogBody = false,
  size = null,
  ...rest
}: ModalWrapperTypes) => {
  useEffect(() => {
    if (onOpen) {
      onOpen();
    }

    if (closeModalOnBackButton) {
      // @ts-ignore
      window.history.pushState(null, null, window.location.pathname);
      window.addEventListener('popstate', onBackButtonEvent);
      return () => {
        window.removeEventListener('popstate', onBackButtonEvent);
      };
    }
  }, []);

  // @ts-ignore
  const onBackButtonEvent = (e) => {
    e.preventDefault();
    onClose();
  };

  return (
    <ModalDialog
      body={
        isWide && !useChildrenForDialogBody ? (
          // @ts-ignore
          <StyledModalWrapperContainer hasBodyMargin={hasBodyMargin}>{children}</StyledModalWrapperContainer>
        ) : (
          children
        )
      }
      footer={footer && footer}
      header={heading ? <Heading level={5}>{heading}</Heading> : null}
      isOpen={true}
      onClose={onClose}
      scrollDocument={scrollDocument}
      shouldCloseOnOutsideClick={shouldCloseOnOverlayClick}
      portal={portal}
      renderCloseButton={<CloseButton data-test="modal-close-button" />}
      size={size ? size : { md_lte: 'fullScreen', default: isWide ? 'md' : 'xs' }}
      {...rest}
    />
  );
};

export default ModalWrapper;
